import { IsString, IsEmail, IsBoolean } from "class-validator";
import { Expose, Type } from "class-transformer";


export class AuthActiveUserDTO {
    @Expose()
    @IsString()
	firstName: string;

	@Expose()
    @IsEmail()
	email: string;

    @Expose()
    @IsBoolean()
    isEmailVerified: boolean;

    @Expose()
    @Type(() => String)
    featureFlags: string[];

    hasFeature(featureFlag: string): boolean {
        return this.featureFlags.includes(featureFlag);
    }

    updateField(data: Partial<AuthActiveUserDTO>) {
        for (const [k, v] of Object.entries(data)) {
            this[k] = v;
        }
    }
}
